import React from 'react';

const Checkout = () => {
  return (
    <div className="min-h-screen bg-secondary-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-secondary-900 mb-8">Checkout</h1>
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          <p className="text-secondary-600">Checkout page coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
